<template>
    <div>
        <v-container>
            <v-row>
                <v-col cols='12'><h4>درخواست {{ translate[$route.params.service] }} برای مجموعه
                    {{ apartment.title }} </h4></v-col>
                <v-col>
                    <info-alert>
                        در قسمت توضیحات تمام اطلاعات تکمیلی مجموعه و مرتبط با خدمت مورد نظر را به طور کامل شرح دهید.
                    </info-alert>
                </v-col>
            </v-row>
            <v-row v-if='!loading'>
                <!--province-->
                <v-col cols='12' sm='4'>
                    <v-autocomplete
                        v-model='apartment.province'
                        :rules='rules.apartment.province'
                        :items='provinceOptions'
                        item-text='title'
                        item-value='_id'
                        no-data-text='یافت نشد'
                        required
                        disabled
                        @focus='hideNavigationBar'
                        @blur='showNavigationBar'
                    >
                        <template #label>
                            <span class='red--text'><strong>* </strong></span>استان
                        </template>
                    </v-autocomplete>
                </v-col>
                <!--city-->
                <v-col cols='12' sm='4'>
                    <v-autocomplete
                        v-model='apartment.city'
                        :rules='rules.apartment.city'
                        :items='cityOptions'
                        item-text='title'
                        item-value='_id'
                        no-data-text='موردی یافت نشد'
                        required
                        disabled
                        @focus='hideNavigationBar'
                        @blur='showNavigationBar'
                    >
                        <template #label>
                            <span class='red--text'><strong>* </strong></span>شهر
                        </template>
                    </v-autocomplete>
                </v-col>
                <!--address-->
                <v-col cols='12' sm='4'>
                    <v-text-field
                        v-model='apartment.address'
                        :rules='rules.apartment.address'
                        required
                        @focus='hideNavigationBar'
                        @blur='showNavigationBar'
                        disabled
                    >
                        <template #label>
                            <span class='red--text'><strong>* </strong></span>آدرس
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols='12'>
                    <v-text-field
                        v-model='description'
                        required
                    >
                        <template #label>
                            متن درخواست و توضیحات
                        </template>
                    </v-text-field>
                </v-col>
                <v-col>
                    <v-btn color='primary' @click='createSupportReq(translate[service])'>
                        ثبت درخواست
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog
            persistent
            class='text-center'
            v-model='checkSupportModal'
            max-width='420'
        >
            <v-card>
                <v-card-title>
                    درخواست شما ثبت شد.
                </v-card-title>
                <v-card-text>
                    پس از ثبت درخواست خدمات، تیم فروش ملکبا جهت ارائه خدمات با شما تماس گرفته و پس از تکمیل اطلاعات،
                    صورت حساب درخواست مورد نظر برایتان صادر خواهد شد.
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn

                        color='text'
                        outlined
                        :to='{name:"SupportRequest", params:{supReq_id: supportRequest_id}}'
                    >
                        مشاهده درخواست پشتیبانی
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                        color='primary'
                        outlined
                        :to="{name:'Apartment'}"
                    >
                        بازگشت به مجموعه
                    </v-btn>



                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import {mapActions, mapState} from 'vuex';

import InfoAlert from '@/components/Alerts/InfoAlert';
import {createSupportRequest} from '@/plugins/createSupportRequest';

export default {
    name: 'form',
    components: {InfoAlert},
    data() {
        return {
            service: null,
            supportRequest: {},
            supportRequest_id: null,
            checkSupportModal: false,
            description: null,
            loading: true,
            provinceOptions: [],
            apartment: {},
            rules: {
                apartment: {
                    province: [
                        v => !!v || 'استان اجباری میباشد'
                    ],
                    city: [
                        v => !!v || 'شهر اجباری میباشد'
                    ],
                    address: [
                        v => !!v || 'آدرس اجباری میباشد'
                    ]

                }
            }
        };
    },
    methods: {
        async createSupportReq(service) {
            createSupportRequest('serviceRequest', {
                apartment: this.apartment._id ? this.apartment._id : this.$route.params.apartment_id,
                text: this.description,
                service: service
            }).then(res => {
                let message = `درخواست شما ثبت شد`;
                this.$snackbar.showMessage({content: message, color: 'success'});
                this.supportRequest = res.data.supportRequest;
                this.supportRequest_id = res.data.supportRequest._id;
                this.checkSupportModal = true;
            }).catch(error => {
                console.error(error);
            });
        },
        async fetchProvinces() {
            await axios
                .get('/api/provinces')
                .then(res => {
                    this.provinceOptions = res.data.provinces;
                })
                .catch(err => {
                    console.error(err);
                });
        },
        hideNavigationBar() {
            this.showNavigation(false);
        },
        showNavigationBar() {
            this.showNavigation(true);
        },
        async checkApartmentRequiredInfo() {
            this.loading = true;
            await axios
                .get(`/api/apartments/${this.$route.params.apartment_id}`)
                .then(res => {
                    this.apartment = res.data.apartment;
                })
                .catch(error => {
                    console.error(error);
                });
            this.loading = false;
        },
        ...mapActions([
            'setRole',
            'showNavigation',
            'showBreadCrumbs',
            'setBreadCrumbsTemp'
        ])
    },
    async created() {
        this.service = this.$route.params.service;
        await this.fetchProvinces();
        await this.checkApartmentRequiredInfo();

        this.setBreadCrumbsTemp({
            key: 'serviceForm',
            value: {
                text: `درخواست خدمات`,
                href: `/apartments/${this.$route.params.apartment_id}/services`
            }
        });
    },
    async updated() {
        await this.showBreadCrumbs(['home', 'apartmentDetail', 'services', 'serviceForm']);
    },
    computed: {
        cityOptions() {
            if (this.provinceOptions.length > 0 && this.apartment.province) {
                return this.provinceOptions.find(item => {
                    if (item._id === this.apartment.province._id) return item;
                }).cities;
            }
            return [];
        },
        ...mapState({
            public_url: state => state.public_url,
            translate: state => state.translate.fa.service,
            user: state => state.user
        })
    }
};
</script>

<style scoped>

</style>